export function resolveEvidenceFrames(boundaryFrame?: number, evidenceFrames?: number[]): number[] {
  if (evidenceFrames?.length) return evidenceFrames;
  if (boundaryFrame === undefined) return [];

  return [-2, -1, 0, 1, 2]
    .map((offset) => boundaryFrame + offset)
    .filter((frame) => frame >= 0);
}
